<template>
  <ODialog ref="dialog" :maxWidth="600" hideWhenLoading>
    <v-card v-if="row != null">
      <ODialogBar title="Associar Módulo a Veículo" @close="dismiss" />

      <template v-if="row.vehicleId != null">
        <v-card-text class="pa-6 text-body-1">
          Este módulo já está associado a um veículo. Use a operação
          "Desassociar" para retirar o módulo ou "Trocar Módulo" para
          substituí-lo por outro.
        </v-card-text>
        <v-card-actions class="pa-6">
          <v-spacer />
          <v-btn text large @click="dismiss">OK</v-btn>
        </v-card-actions>
      </template>

      <template v-else-if="currentTab == 1">
        <v-card-text class="px-4 py-6">
          <v-text-field
            autofocus
            filled
            class="elevation-0"
            v-model="txtFilter"
            placeholder="Buscar por placa/código auxiliar..."
            single-line
            hide-details
            append-inner-icon="mdi-magnify"
          />
        </v-card-text>

        <OSelectList2
          px="6"
          class="maxh-4 px-0"
          eachClass="px-7"
          :rows="filteredVehicles"
          @click="selectVehicle"
        >
          <template v-slot:default="{ row }">
            <v-list-item-title>
              <OSpans :pieces="[row.code, row.extraCode]" />
            </v-list-item-title>
            <v-list-item-subtitle style="line-height: 22px">
              <OSpans
                style="opacity: 0.7"
                eachClass="tag mr-1"
                :pieces="row.chips"
              />
            </v-list-item-subtitle>
          </template>
        </OSelectList2>

        <v-card-text class="pa-6 red--text" v-if="errVehicleHasClient">
          Este veículo já tem um módulo associado! Use a operação "Trocar
          Módulo" se quiser substituir aquele por este.
        </v-card-text>
      </template>

      <template v-if="currentTab == 2">
        <div class="px-4 py-6">
          <div class="grey lighten-3 pa-3 mb-3 rounded-lg">
            <OCapCont label="Módulo">
              <b>{{ clientId }}</b>
            </OCapCont>
          </div>
          <div class="grey lighten-3 pa-3 mb-3 rounded-lg">
            <OCapCont label="Veículo">
              <b>{{ newVehicle.code }}</b>
              <span v-if="newVehicle.extraCode != null"
                >({{ newVehicle.extraCode }})</span
              >
              no sistema
              <b>{{ newVehicle.org.name }}</b>
            </OCapCont>
          </div>
          <div class="pa-3 mb-3">
            Serão gerados mailboxes de motoristas, inteligências, polígonos, e
            configurações.
          </div>
        </div>
        <ODialogButtons
          class="pa-6"
          txtApply="Sim, associar"
          txtCancel="Não, cancelar"
          @apply="apply"
          @cancel="currentTab = 1"
        />
      </template>
    </v-card>
  </ODialog>
</template>

<script>
import { Client, Vehicle, go } from '@/models'
import utils from 'oderon-commons/src/utils'
import OSelectList2 from 'oderon-vue/cpts/OSelectList2.vue'

export default {
  components: { OSelectList2 },
  data() {
    return this.reset()
  },
  computed: {
    filteredVehicles() {
      const match = (x) =>
        utils.matchAnyLike(this.txtFilter, x.code, x.extraCode)
      return this.allVehicles.filter(match).slice(0, 20)
    }
  },
  methods: {
    reset() {
      return {
        row: null,
        clientId: null,
        txtFilter: null,
        allVehicles: [],
        newVehicle: null,
        currentTab: 1,
        errVehicleHasClient: false,
        errDetails: null
      }
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    open({ clientId }) {
      Object.assign(this, this.reset())
      this.clientId = clientId
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      let rows = await Vehicle.findMini()
      rows.forEach((r) => {
        r.chips = []
        r.chips.push({ text: r.org.name })

        let tags = r.tags || []

        let group = tags.find((x) => x.toLowerCase().startsWith('grupo:'))
        if (group) r.chips.push({ text: group, cssClass: 'blue' })

        if (r.brandModel) r.chips.push({ text: r.brandModel.name })

        let desmob = tags.find((x) => x.toLowerCase() == 'desmobilizado')
        if (desmob) r.chips.push({ text: desmob, cssClass: 'red' })
      })
      this.allVehicles = rows
      this.row = await Client.findById(this.clientId)
    },

    async selectVehicle(newVehicle) {
      if (newVehicle.clientId != null) {
        this.errVehicleHasClient = true
      } else {
        this.newVehicle = newVehicle
        this.errVehicleHasClient = false
        this.currentTab = 2
      }
    },

    apply() {
      this.$rootLoading(async () => {
        let body = { vehicleId: this.newVehicle.id }
        await go.post(`/clients/${this.clientId}/associate`, body)
        this.$snack('Associado com sucesso')

        this.$refs.dialog.$apply('RELOAD')
      })
    }
  }
}
</script>

<style></style>
